import React from "react"
import { Alert, Snackbar } from "@mui/material"

export default class DuplicateErrorMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
    }
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { duplicateFileNames } = this.props
    const { open } = this.state
    return (
      <Snackbar
        open={open}
        autoHideDuration={8000}
        onClose={this.handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={this.handleClose} severity="error">
          These sounds have already been uploaded:
          <ul>
            {duplicateFileNames.map((filename) => {
              return <li key={filename}>{filename}</li>
            })}
          </ul>
        </Alert>
      </Snackbar>
    )
  }
}
